import { DemoUser } from "@models/DemoUser";
import { CoreDependencies } from "./CoreDependencies";
import { v4 as uuid } from 'uuid';
import { Logger } from "@utils/Logger";
import { QontactUser } from "@models/QontactUser";

export class Application {
    private static instance: Application

    private constructor() {}
    private _coreDependencies: CoreDependencies
    private _currentUser?: DemoUser
    private _session: string
    private _token: string
    private _onSessionExpired?: () => void

    public static shared(): Application {
        if (!Application.instance) {
            Application.instance = new Application()
            Application.instance._session = uuid()
        }
        return Application.instance;
    }

    public static setDependencies(coreDependencies: CoreDependencies) {
        Application.shared()._coreDependencies = coreDependencies
    }

    public get coreDependencies(): CoreDependencies {
        return this._coreDependencies
    }

    public setToken(token: string) {
        this._token = token
        this._coreDependencies.setAPIToken(token)
    }

    public setUser(user: DemoUser) {
        this._currentUser = user
        let qontactUser: QontactUser = {
            id: user.mobilePhoneNumber,
            name: user.name,
            email: user.email,
            photoURL: ""
        }
        this._coreDependencies.analytics.setUser(qontactUser)
    }

    public get user(): DemoUser {
        return this._currentUser
    }

    public get token(): string {
        return this._token
    }

    public get timezone(): string {
        return this.user.timezone ?? 'America/Argentina/Buenos_Aires'
    }

    public get session(): string {
        return this._session
    }

    public setOnSessionExpired(callback: () => void) {
        this._onSessionExpired = callback
    }

    public handleSessionExpired() {
        Logger.log("Application", "handle session expired")        
        this._onSessionExpired?.()
        // Optionally clear token/user here
        this._token = ''
        this._currentUser = undefined
    }
}